import {
  type SmartIdLoginChallengeMutationVariables,
  useSmartIdLoginChallengeMutation,
  useSmartIdLoginPollLazyQuery,
} from 'api/core/generated';
import { APP_POLLING_INTERVALS, AppApiVersions } from 'app-constants';

export const useLoginBySmartId = () => {
  const [smartIdLoginRequest, { data, loading, error }] =
    useSmartIdLoginChallengeMutation({
      context: { apiVersion: AppApiVersions.core },
    });

  const [
    getSmartIdState,
    {
      data: pollData,
      loading: pollLoading,
      error: pollError,
      startPolling,
      stopPolling,
    },
  ] = useSmartIdLoginPollLazyQuery({
    context: { apiVersion: AppApiVersions.core },
    fetchPolicy: 'network-only',
    pollInterval: APP_POLLING_INTERVALS.default,
  });

  const loginBySmartId = (variables: SmartIdLoginChallengeMutationVariables) =>
    smartIdLoginRequest({ variables });

  return {
    loginBySmartIdProcessing: loading,
    smartIdChallengeData: data?.challenge,
    loginBySmartIdError: error,
    loginBySmartId,
    getSmartIdState,
    startSmartIdStatePolling: startPolling,
    stopSmartIdStatePolling: stopPolling,
    smartIdPollData: pollData?.challenge ?? {},
    smartIdPollLoading: pollLoading,
    smartIdPollError: pollError,
    authorizedBySmartId: Boolean(pollData?.challenge?.is_authenticated),
  };
};
